module.exports = __webpack_public_path__ + "img/icon-fom-view-form.def9a34b.png";